<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-button type="primary" @click="$router.push({name: 'FaqFormAdd'})">Qo'shish</el-button>
    </div>
    <el-table :data="data" class="table" border height="calc(100vh - 270px)">
      <el-table-column prop="question" label="Savollar"/>
      <el-table-column prop="answer" label="Murojaat muallifi"/>
      <el-table-column label="" width="200" align="center">
        <template #default="scope">
          <el-button type="primary" size="small"
                     @click="$router.push({name: 'FaqFormEdit', params:{id: scope.row.id}})">Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span v-if="totalElements">Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15,20,30,50,100,200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "FaqList",
  data() {
    return {
      loading: false,
      data: [],

      totalElements: 0,
      totalPages: null,
      size: 20,
      page: 1,
    }
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
  },
  methods: {
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Savolni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v2/info/faq/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getFaqList();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          }).then(() => {
        this.getFaqList();
      }).catch(() => {
      });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          }).then(() => {
        this.getFaqList();
      }).catch(() => {
      });
    },
    getFaqList() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size ? parseInt(this.$route.query.size || "") : 20;
      this.$http.get(`api/v2/info/faq`, {
        params: {
          page: this.page - 1,
          size: this.size
        }
      }).then(({data}) => {
        this.data = data.content
        this.totalElements = data.totalElements;
        this.totalPages = data.totalPages;
        this.size = data.size;
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })

    }
  },
  mounted() {
    this.getFaqList()
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

:deep(.el-table .el-table__cell) {
  z-index: unset !important;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  height: 40px;
}

.pagination-wrapper > span {
  color: #0A194E;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>